import React, { useEffect, useState } from 'react'
import HorizontalSeparator from '../../../../components/separator/horizontalSeparator/HorizontalSeparator'
import commonStyles from "../PaymentDrawer.styles"
import Label from '../../../../components/label/Label'
import Icons from '../../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import Heading from '../../../../components/heading/Heading'
import { HEADING } from '../../../../components/heading/constants/constants'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey as dataLoaderKey } from '../../../loaders/dataloader/DataLoaderSlice'
import Button from '../../../../components/button/Button'
import { BUTTON_TYPE } from '../../../../components/button/constants';
import styles from "./BillDetails.styles"
import { AddressInformationCard } from '../addressinformationcard/AddressInformationCard'
import { MINIMUM_PREPAY_THRESHOLD, PAYMENT_DRAWER_LOADING_STATES, PAYMENT_DRAWER_MESSAGE_MAP, PAYMENT_STEPS, PLACE_OF_ORIGIN_FOR_PAYMENT, SHOW_COUPON_CODE_OPTION_FOR } from '../constants'
import { componentKey as paymentDrawerComponentKey, setBillingDetails, setCurrentPaymentStep, setDisableEnterAmountField, setIsCardPayment, setPaymentDrawerShowOnSuccessNavigationBtnsState } from '../PaymentDrawerSlice'
import TextInput from '../../../../components/input/textinput/TextInput'
import { Theme } from '../../../../components/constants'
import { applyCoupon } from '../PaymentDrawerSaga'
import { setEnteredAmount } from '../addfunds/AddFundsSlice'
import { addNotifications } from '../../../toaster/ToasterPortalSlice'
import { TOASTER_VARIANT } from '../../../../components/toast/constants'
import General from '../../../../../libs/utility/General'
import Loadable from '../../../../components/loadable/Loadable'
import { ESTIMATED_TAX, E_DELIVERY_FEE, FIELD_COUPON, FILING_FEE, SALES_TAX, STATE_FILING_FEE, TIN_VERIFICATION_FEE, USPS_MAILING_FEE } from './constants'
import TxTooltipWIcon from '../../../../components/tooltip/txtooltipwicon/TxTooltipWIcon'
import InformationPopup from '../../../../components/popup/informationpopup/InformationPopup'
import { useNavigate } from 'react-router-dom'
import { ACCOUNT_SECTION_ROUTES } from '../../../constants/constants'

const BillDetails = ({
    calculateEstimatedTax = false,
    onChangeSalesTax = () => { },
    onPayNowCb = () => { },
    placeOfOriginforpayment = PLACE_OF_ORIGIN_FOR_PAYMENT.SUBMIT_FORM_PAGE,
    filingFeeLabel = FILING_FEE
}) => {

    const { loadingState, payNowCbLoadingState, billingDetails, estimatedTaxCalculationComplete, isSubscription, isUsps } = useSelector(state => state[paymentDrawerComponentKey]);
    const { TotalFilingFee, FilingFee, USPSFee, TINMatchFee, StateFee, EstimatedTax, Coupon, DiscountAmount, FinalFilingFee, eDeliveryFee } = billingDetails;
    const [estimatedTaxLabel, setEstimatedTaxLabel] = useState(ESTIMATED_TAX)
    const { prepayAmount } = useSelector(state => state[dataLoaderKey]);
    const [showAddressInformationCard, setShowAddressInformationCard] = useState(false);
    const [isPopupVisible, setPopupVisible] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const discountStyles = DiscountAmount > 0 ? { textDecoration: "line-through", color: Theme.ERROR_TEXT } : {};

    const handleSalesTaxOnChange = (data, addressInformation) => {
        setEstimatedTaxLabel(SALES_TAX);
        onChangeSalesTax(data, addressInformation);
    }

    useEffect(() => {
        if (billingDetails?.DiscountCode) {
            dispatch(setBillingDetails({ [FIELD_COUPON]: billingDetails?.DiscountCode }))
            handleApplyCouponBtnClk(billingDetails?.DiscountCode);
        }
    }, [billingDetails?.DiscountCode])

    const handleApplyCouponBtnClk = (couponCode) => {
        dispatch(applyCoupon({ coupon: couponCode, filingFee: FilingFee, totalFilingFee: TotalFilingFee }))
    }
    const togglePopup = () => {
        setPopupVisible(!isPopupVisible);
    };

    const handleSalesTaxPopupbtnClick = () => {
        navigate(`/${ACCOUNT_SECTION_ROUTES.ACCOUNT_TEXT}/${ACCOUNT_SECTION_ROUTES.GENERAL_TEXT}`);
    }

    return (
        <Loadable
            currentState={payNowCbLoadingState.state}
            loadingStates={[PAYMENT_DRAWER_LOADING_STATES.PAY_NOW_LOADING]}
            messageMap={PAYMENT_DRAWER_MESSAGE_MAP}
            isNewLoadable={true}
        >
            <div style={commonStyles.bodyContainer}>

                {
                    (placeOfOriginforpayment === PLACE_OF_ORIGIN_FOR_PAYMENT.SUBMIT_FORM_PAGE || FilingFee > 0) &&
                    <>
                        <HorizontalSeparator style={commonStyles.horizontalLine} />
                        <div>
                            <div style={commonStyles.formInfo}>
                                <Label customStyles={commonStyles.formName}>{filingFeeLabel}</Label>
                                <span style={commonStyles.amount}>${filingFeeLabel.includes("Payroll") ? (TotalFilingFee ?? 0) : (FilingFee ?? 0)}</span>
                            </div>
                        </div>
                    </>

                }

                {
                    (placeOfOriginforpayment === PLACE_OF_ORIGIN_FOR_PAYMENT.SUBMIT_FORM_PAGE || TINMatchFee > 0) &&
                    <>
                        <HorizontalSeparator style={commonStyles.horizontalLine} />
                        <div>
                            <div style={commonStyles.formInfo}>
                                <Label customStyles={commonStyles.formName}>{TIN_VERIFICATION_FEE}</Label>
                                <span style={commonStyles.amount}>${General.getDecimalAmount(TINMatchFee) ?? 0}</span>
                            </div>
                        </div>
                    </>
                }

                {
                    (placeOfOriginforpayment === PLACE_OF_ORIGIN_FOR_PAYMENT.SUBMIT_FORM_PAGE || USPSFee > 0) &&
                    <>
                        <HorizontalSeparator style={commonStyles.horizontalLine} />
                        <div>
                            <div style={commonStyles.formInfo}>
                                <Label customStyles={commonStyles.formName}>{USPS_MAILING_FEE}</Label>
                                <span style={commonStyles.amount}>${General.getDecimalAmount(USPSFee) ?? 0}</span>
                            </div>
                        </div>
                    </>
                }

                {
                    (placeOfOriginforpayment === PLACE_OF_ORIGIN_FOR_PAYMENT.SUBMIT_FORM_PAGE || eDeliveryFee > 0) &&
                    <>
                        <HorizontalSeparator style={commonStyles.horizontalLine} />
                        <div>
                            <div style={commonStyles.formInfo}>
                                <Label customStyles={commonStyles.formName}>{E_DELIVERY_FEE}</Label>
                                <span style={commonStyles.amount}>${General.getDecimalAmount(eDeliveryFee) ?? 0}</span>
                            </div>
                        </div>
                    </>
                }

                {
                    (placeOfOriginforpayment === PLACE_OF_ORIGIN_FOR_PAYMENT.SUBMIT_FORM_PAGE || StateFee > 0) &&
                    <>
                        <HorizontalSeparator style={commonStyles.horizontalLine} />
                        <div>
                            <div style={commonStyles.formInfo}>
                                <Label customStyles={commonStyles.formName}>{STATE_FILING_FEE}</Label>
                                <span style={commonStyles.amount}>${General.getDecimalAmount(StateFee) ?? 0}</span>
                            </div>
                        </div>
                    </>
                }

                <HorizontalSeparator style={commonStyles.horizontalLine} />
                <>
                    <div style={commonStyles.formInfo}>
                        <Label customStyles={commonStyles.formName}>{estimatedTaxLabel}</Label>
                        <div style={commonStyles.tooltipIcon}>
                            <div onClick={togglePopup}>
                                <TxTooltipWIcon
                                    id={"salestax-tooltip"}
                                    text={"click here to see more info.."}
                                />
                            </div>
                            <span style={commonStyles.amount}>
                                ${General.getDecimalAmount(EstimatedTax) ?? 0}
                            </span>
                        </div>

                        <InformationPopup
                            title={"SalesTax Exemption Information"}
                            bodyText={"If you have any salestax exemption certificate please follow below link to proceed "}
                            iconName={VEC_ICON_NAME.INFO_ICON}
                            isOpen={isPopupVisible}
                            confirmationButtonProps={{
                                onConfirmationCb: () => (setPopupVisible(false)),
                                confirmationButtonText: "Ok",
                                confirmationButtonType: BUTTON_TYPE.PRIMARY,
                            }}
                            showClose={false}
                            customBodyContainerStyle={commonStyles.popupFlexDirection}
                        >
                            <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={handleSalesTaxPopupbtnClick} style={commonStyles.marginTopBtn}>click here</Button>
                        </InformationPopup>
                    </div>

                    {calculateEstimatedTax && <>
                        <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={() => setShowAddressInformationCard(!showAddressInformationCard)}>Click here to Calculate Sales Tax</Button>

                        {showAddressInformationCard &&
                            <AddressInformationCard
                                isSubscription={isSubscription}
                                isUsps={isUsps}
                                uspsAmount={General.getNumberAmount(USPSFee)}
                                totalAmount={General.getNumberAmount((General.getNumberAmount(TotalFilingFee)).toFixed(2))}
                                salesTaxSuccessCb={handleSalesTaxOnChange}
                            />
                        }
                    </>}

                    <HorizontalSeparator style={commonStyles.horizontalLine} />
                </>


                {calculateEstimatedTax && SHOW_COUPON_CODE_OPTION_FOR.includes(placeOfOriginforpayment) &&
                    <>
                        <div style={commonStyles.formInfo}>
                            <Loadable
                                currentState={loadingState.state}
                                loadingStates={[PAYMENT_DRAWER_LOADING_STATES.APPLY_COUPON_LOADING]}
                                messageMap={PAYMENT_DRAWER_MESSAGE_MAP}
                                isNewLoadable={true}
                            >
                                <Label customStyles={commonStyles.formName}>Coupon</Label>

                                <div style={styles.couponContainer}>
                                    <TextInput
                                        name={FIELD_COUPON}
                                        value={Coupon}
                                        onChangeCb={(e) => dispatch(setBillingDetails({ [e.target.name]: e.target.value }))}
                                    />


                                    <Button style={styles.applyButton} onClickCb={() => {
                                        if (Coupon) {
                                            handleApplyCouponBtnClk(Coupon);
                                        } else {
                                            dispatch(addNotifications({ heading: "Error", message: "Please enter the coupon" }))
                                        }
                                    }}>Apply</Button>
                                </div>
                            </Loadable>
                        </div>
                        <HorizontalSeparator style={commonStyles.horizontalLine} />
                    </>
                }


                <div style={commonStyles.totalBox}>
                    <Heading type={HEADING.H1}>Total amount</Heading>

                    <div>
                        <Heading type={HEADING.H1} customStyle={discountStyles}>
                            ${General.getDecimalAmount(General.getNumberAmount(TotalFilingFee) + General.getNumberAmount(EstimatedTax))}
                        </Heading>
                        {DiscountAmount > 0 ? <Heading type={HEADING.H1}>
                            ${General.getDecimalAmount(General.getNumberAmount(FinalFilingFee) + General.getNumberAmount(EstimatedTax))}
                        </Heading> : null}
                    </div>
                </div>

                <div style={styles.prepayIconContainer}>
                    <Icons familyName="vec" iconName={VEC_ICON_NAME.WALLET_ICON_WITH_BOX} />
                    <Label customStyles={commonStyles.walletText}>You have ${General.getDecimalAmount(prepayAmount)} in your Prepay wallet</Label>

                    <div style={styles.paynowBtnContainer}>
                        <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => {
                            if (!estimatedTaxCalculationComplete) {
                                dispatch(addNotifications({ heading: "Error", message: "Please calculate the sales tax" }))
                            } else if (General.getNumberAmount(prepayAmount) - (General.getNumberAmount(FinalFilingFee) + General.getNumberAmount(EstimatedTax)) >= 0) {
                                onPayNowCb();
                            } else {
                                dispatch(addNotifications({ heading: "Insufficient Balance", message: `Please pay the${prepayAmount == 0 ? '' : ' remaining'} amount using card. Scroll down and click on Pay using card`, variant: TOASTER_VARIANT.WARNING }))
                            }
                        }} style={commonStyles.nextButton}>
                            Pay Now
                        </Button>
                    </div>
                </div>

                <div style={styles.alternatePaymentOptions}>
                    {General.getNumberAmount(prepayAmount) - (General.getNumberAmount(FinalFilingFee) + General.getNumberAmount(EstimatedTax)) < 0 && <>
                        <Button
                            type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                            onClickCb={() => {
                                dispatch(setIsCardPayment(true))
                                dispatch(setCurrentPaymentStep(PAYMENT_STEPS.ADD_FUNDS));
                                dispatch(setEnteredAmount(General.getNumberAmount((General.getNumberAmount(FinalFilingFee) - General.getNumberAmount(prepayAmount)).toFixed(2))))
                                dispatch(setDisableEnterAmountField(true));
                            }}
                            style={styles.linkBtn}
                        >
                            Pay Using Card
                        </Button>

                        <span>or</span>
                    </>
                    }

                    {General.getNumberAmount(prepayAmount) - (General.getNumberAmount(FinalFilingFee) + General.getNumberAmount(EstimatedTax)) <= 0 && <Button
                        type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                        onClickCb={() => {
                            dispatch(setPaymentDrawerShowOnSuccessNavigationBtnsState(false))
                            dispatch(setCurrentPaymentStep(PAYMENT_STEPS.ADD_FUNDS))
                        }
                        }
                        style={styles.linkBtn}

                    >
                        Add Prepay Balance
                    </Button>}
                </div>

            </div>
        </Loadable>
    )
}

export default BillDetails
